import { Grid, Typography } from '@mui/material'
import Image from 'next/image'
import React from 'react'
import useStyles from './Style'
import { useRouter } from 'next/router'
import clsx from 'clsx'
import { ChangeMakerContent } from 'src/types/components/shared/atom'

interface IProps {
  zenMode: boolean
  content: ChangeMakerContent
}
const ChangeMaker: React.FC<IProps> = ({ zenMode, content }) => {
  const { classes } = useStyles()
  const router = useRouter()

  return (
    <Grid
      container
      className={classes.rootContainer}
      onClick={() => {
        router.push('careers')
      }}
    >
      <Grid
        item
        md={6}
        sm={12}
        xs={12}
        sx={{
          order: { lg: 0, md: 0, sm: 2, xs: 2 },
        }}
      >
        <Grid
          className={clsx(
            classes.leftSectionContainer,
            zenMode && classes.leftSectionZenContainer
          )}
          sx={{
            backgroundImage: zenMode
              ? 'none'
              : ` linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%),url(${content.changeMakerBg})`,
          }}
        >
          <Grid
            className={clsx(
              classes.imgCaptionContainer,
              zenMode && classes.imgCaptionZenContainer
            )}
          >
            <Grid sx={{ display: 'flex', alignItems: 'center' }}>
              <Grid
                className={classes.imgContainer}
                sx={{ display: zenMode ? 'none' : 'flex' }}
              >
                <Image alt="logo" src={content.logoImg} fill />
              </Grid>
              <Typography className={classes.logoText}>
                {content.logoText}
              </Typography>
            </Grid>
            <Grid>
              <Typography className={classes.logoPara}>
                {content.logoPara}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        md={0.7}
        sx={{ display: { md: 'flex', sm: 'none', xs: 'none' } }}
      >
        {' '}
      </Grid>
      <Grid
        item
        md={5}
        sm={12}
        xs={12}
        container
        alignItems="center"
        sx={{
          order: { lg: 2, md: 2, sm: 1, xs: 1 },
          marginBottom: { md: '0px', sm: '40px' },
        }}
      >
        <Grid className={classes.rightSectionContainer}>
          <Typography className={classes.rightHeading}>
            {content.rightHeading}
          </Typography>
          <Typography className={classes.rightSubHeading}>
            {content.rightSubHeading}
          </Typography>
          <Typography className={classes.rightPara}>
            {content.rightPara}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ChangeMaker
